import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';

export function initHeroGrid() {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.js-hero-grid').forEach((el) => {
            new Swiper(el, {
                modules: [Autoplay, FreeMode],
                slidesPerView: 1.5,
                spaceBetween: 8,
                loop: true,
                grabCursor: true,
                speed: 20000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                freeMode: {
                    enabled: true,
                    momentum: false,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3.5,
                        spaceBetween: 24,
                    },
                },
            });
        });
    });
}
